import "@assets/styles/main.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import "react-toastify/dist/ReactToastify.css";
import "leaflet/dist/leaflet.css";
import "video-react/dist/video-react.css";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

import { Layout } from "@components/common";
import { AppProps } from "next/app";
import { Router } from "next/router";
import { useEffect, useRef, useState } from "react";
import { Hydrate, QueryClient, QueryClientProvider } from "react-query";
import { Bounce, ToastContainer } from "react-toastify";
import LoadingBar from "react-top-loading-bar";
import { wrapper } from "store";

function MyApp({ Component, pageProps }: AppProps) {
  // Create a new query client
  const [queryClient] = useState(() => new QueryClient());
  const getLayout =
    (Component as any).getLayout || ((page: any) => <Layout>{page}</Layout>);
  const ref: any = useRef(null);

  useEffect(() => {
    const start = () => {
      ref?.current?.continuousStart();
    };
    const end = () => {
      ref?.current?.complete();
    };
    Router.events.on("routeChangeStart", start);
    Router.events.on("routeChangeComplete", end);
    Router.events.on("routeChangeError", end);
    return () => {
      Router.events.off("routeChangeStart", start);
      Router.events.off("routeChangeComplete", end);
      Router.events.off("routeChangeError", end);
    };
  }, []);

  return (
    <>
      <>
        <LoadingBar
          style={{ direction: "ltr" }}
          containerStyle={{ direction: "ltr" }}
          shadowStyle={{ direction: "ltr" }}
          color="#f11946"
          shadow={true}
          ref={ref}
        />

        <ToastContainer
          closeButton={false}
          hideProgressBar
          autoClose={1000}
          className={"font-sans"}
          transition={Bounce}
          position={"bottom-right"}
          icon={false}
        />
        <QueryClientProvider client={queryClient}>
          <Hydrate state={pageProps.dehydratedState}>
            {getLayout(<Component {...pageProps} />)}
          </Hydrate>
        </QueryClientProvider>
      </>
    </>
  );
}

export default wrapper.withRedux(MyApp);
